var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('ring-loader')],1):_c('div',[_c('public-sessions',{attrs:{"mySlot":_vm.sessionsList,"slotsCategoriesOptions":_vm.category}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }